import * as Yup from 'yup';
import * as helpers from '~/Utils/Helpers';

const socioSchemaValidacoes = Yup.object().shape({
  tipo_pessoa: Yup.number()
    .required('Selecione o tipo de pessoa')
    .test(
      'validacao-conjuge-socio-tipo-pessoa',
      'Opção incompatível com o tipo do sócio/cônjuge',
      function(value) {
        const { tipo_conjuge_socio } = this.parent;
        return !(
          value.toString() === '1' && tipo_conjuge_socio.toString() === '1'
        );
      }
    ),
  nome: Yup.string().when('tipo_pessoa', {
    is: 0,
    then: schema =>
      schema
        .required('Informe o nome')
        .matches(/^[^\d]*$/, 'O nome não pode conter números'),
    otherwise: schema => schema.required('Informe o nome'),
  }),
  email: Yup.string()
    .email('Informe um email válido')
    .matches(
      /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
      'Informe um email no formato válido'
    ),
  tel_celular: Yup.string().test(
    'celular-valido',
    'Número de celular inválido',
    function(value) {
      if (!value) return true;
      const apenasNumeros = value.replace(/\D/g, '');
      if (apenasNumeros.length === 11) {
        const ddd = apenasNumeros.substring(0, 2);
        const primeiroDigito = apenasNumeros.charAt(2);
        return (
          parseInt(ddd) >= 11 && parseInt(ddd) <= 99 && primeiroDigito === '9'
        );
      }
      return false;
    }
  ),

  tel_residencial: Yup.string().test(
    'tel-comercial-valido',
    'Número de telefone residencial inválido',
    function(value) {
      if (!value) return true;
      const apenasNumeros = value.replace(/\D/g, '');
      if (apenasNumeros.length === 10) {
        value = helpers.format.celular(value || '');
        return /^(?:\(\d{2}\)\s?)?\d{4}-\d{4}$/.test(value);
      } else if (apenasNumeros.length === 11) {
        value = helpers.format.celular(value || '');
        return /^(?:\(\d{2}\)\s?)?\d{5}-\d{4}$/.test(value);
      }
      return false;
    }
  ),
  tel_comercial: Yup.string().test(
    'tel-comercial-valido',
    'Número de telefone comercial inválido',
    function(value) {
      if (!value) return true;
      const apenasNumeros = value.replace(/\D/g, '');
      if (apenasNumeros.length === 10) {
        value = helpers.format.celular(value || '');
        return /^(?:\(\d{2}\)\s?)?\d{4}-\d{4}$/.test(value);
      } else if (apenasNumeros.length === 11) {
        value = helpers.format.celular(value || '');
        return /^(?:\(\d{2}\)\s?)?\d{5}-\d{4}$/.test(value);
      }
      return false;
    }
  ),
  tipo_conjuge_socio: Yup.string()
    .required('Informe o tipo do sócio/cônjuge')
    .test(
      'tipo-conjuge-socio-invalido-por-titular',
      'Opção incompatível com o estado civil do titular',
      function(value) {
        const {
          prospecto_titular_estado_civil,
          prospecto_titular_tipo_pessoa,
        } = this.parent;
        if (prospecto_titular_tipo_pessoa.toString() !== '1') {
          return !(
            value &&
            value.toString() === '1' &&
            ['0', '7', '8', '9'].includes(
              prospecto_titular_estado_civil.toString()
            )
          );
        }

        return true;
      }
    ),
  sexo: Yup.string().required('Informe o genero'),
  cpf: Yup.string()
    .required('Informe o CPF ou CNPJ')
    .test(
      'cpf-diferente-do-titular',
      'Não é possível repetir o mesmo CPF do titular',
      function(value) {
        if (!value) return;
        const { prospecto_titular_cpf } = this.parent;
        if (!value || !prospecto_titular_cpf) return true;
        const cleanValue = value.replace(/\D/g, '');
        const cleanTitular = prospecto_titular_cpf.replace(/\D/g, '');
        return cleanValue !== cleanTitular;
      }
    ),
  // rg: Yup.string().required('Informe o RG'),
  // orgao_emissor_rg: Yup.string().required('Informe o orgão emissor do RG'),
  // data_emissao_rg: Yup.string().required('Informe a data de emissão do RG'),
  // codigo_profissao: Yup.string().required('Selecione uma profissão'),
  // codigo_nacionalidade: Yup.string().required('Selecione uma nacionalidade'),
  estado_civil: Yup.string()
    .required('Informe o estado civil')
    .test(
      'estado-civil-invalido-para-socio',
      'Opção incompatível com o tipo sócio/cônjuge',
      function(value) {
        if (!value) return;
        const {
          tipo_conjuge_socio,
          prospecto_titular_tipo_pessoa,
        } = this.parent;
        if (prospecto_titular_tipo_pessoa.toString() !== '1') {
          return !(
            tipo_conjuge_socio === '1' &&
            ['0', '7', '8', '9'].includes(value.toString())
          );
        }
        return true;
      }
    ),
  cep: Yup.string().required('Informe o CEP'),
  estado: Yup.string().required('Selecione um estado'),
  codigo_cidade: Yup.string().required('Selecione uma cidade'),
  endereco: Yup.string().required('Informe o endereço'),
  numero: Yup.string().required('Informe o número do imóvel'),
  bairro: Yup.string().required('Informe um bairro'),

  // RG é opcional: saiu dos documentos de venda e não é mais exigido no cadastro.
  rg: Yup.string()
    .when('cpf', (cpf, field) => {
      return field.test('rg-e-cpf', 'O RG não pode ser igual ao CPF', function(
        value
      ) {
        const { path, createError } = this;
        if (
          value &&
          (value || '')
            .toString()
            .replaceAll('.', '')
            .replaceAll('-', '') ===
            (cpf || '')
              .toString()
              .replaceAll('.', '')
              .replaceAll('-', '').length >
              0
        ) {
          return createError({
            path,
            message: 'O RG não pode ser igual ao CPF',
          });
        }
        return true;
      });
    }),
  codigo_profissao: Yup.string().required('Informe uma profissão.'),
});

export default socioSchemaValidacoes;
